import React from 'react';
import { clsx } from 'clsx';
import { COMMON_CLASSES } from '@/styles/classes';

export interface SelectOption {
  value: string | number;
  label: string;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: SelectOption[];
  required?: boolean;
}

export const Select: React.FC<SelectProps> = ({
  label,
  error,
  options,
  required,
  className,
  ...props
}) => {
  return (
    <div>
      {label && (
        <label className={COMMON_CLASSES.label}>
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <select
        className={clsx(
          COMMON_CLASSES.select,
          error && COMMON_CLASSES.inputError,
          className
        )}
        {...props}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="mt-1.5 text-sm text-red-600">{error}</p>}
    </div>
  );
};

